// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.label[data-v-2e098dff]{\r\n\tfont-size:.8em;\r\n\tcolor:var(--main-gray-4);\n}\n.fab[data-v-2e098dff] {\r\n\tposition:sticky;\r\n\tleft: calc(100% - 60px);\r\n\tbottom: 20px;\n}\n.w-container[data-v-2e098dff]{\r\n\tposition: relative;\n}\n.no-rows[data-v-2e098dff]{\r\n\tfont-size:1.2em;\r\n\tcolor: var(--main-gray-5);\n}\r\n\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
